import { isKnown } from "./api";

/**
 * View state lives in the URL HASH, not the path.
 *
 * The CloudFront distribution deliberately carries no SPA error-response fallback —
 * a `CustomErrorResponses` entry is distribution-level and would rewrite `/api/*`
 * 403s into 200 + index.html, so the page could not tell a refusal from success. A
 * path like `/day/2026-09-10` would therefore 404 against S3.
 *
 * A hash also survives being pasted into Slack during an incident, which a
 * sessionStorage preference would not.
 */
export type HashState = {
  account?: string;
  view?: string;
  day?: string;
  month?: string;
  key?: string;
};

const FIELDS = ["view", "day", "month", "key"] as const;

export function readHash(): HashState {
  const p = new URLSearchParams(location.hash.replace(/^#/, ""));
  const out: HashState = {};

  // An account that is no longer in the list is dropped rather than selected: a stale
  // link must fall back to the default, not to nothing.
  const account = p.get("account");
  if (account && isKnown(account)) out.account = account;

  for (const k of FIELDS) {
    const v = p.get(k);
    if (v) out[k] = v;
  }
  return out;
}

export function writeHash(s: HashState): void {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(s)) if (v) p.set(k, v);
  location.hash = p.toString();
}
